import './BubbleComponent.scss';
import { useSelector } from 'react-redux';
import { FilterActions } from '../../../redux/FilterActions';
import { useCallback, FC } from 'react';
import { RootState } from '../../../redux/AppReducer';
import { FilterType, FilterVM, ScreenType } from '../../../common/view-model';
import { validateShowBubble } from './model';
import { useNavigate } from 'react-router';
import { useAppDispatch } from '../../../redux/store';
interface ITopBubblesState {
	filter: FilterVM;
	style?: string;
	onBubbleClick?: () => void;
	disabled: boolean;
	bubblesToShow?: number;
	handleOpenPanel?: () => void;
}

export const BubbleComponent: FC<ITopBubblesState> = ({
	filter,
	style,
	onBubbleClick,
	disabled,
	bubblesToShow,
	handleOpenPanel
}) => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	const homePageUrl = 'products';
	const selectedFilters = useSelector(
		(state: RootState) => state.appState.filterState?.selectedFilters
	);
	const screenType = useSelector((state: RootState) => state.appState.deviceScreen);
	const clickFunctions = useSelector(
		(state: RootState) => state.appState.filterState?.bubbleFunctionRef
	);
	const bubbleClickCallback = useCallback(() => {
		clickFunctions?.find(f => f.type === filter.type)?.value();
	}, [clickFunctions, filter.type]);
	const showBubble = validateShowBubble(filter, selectedFilters);
	const handleBubbleClick = () => {
		if (
			filter?.type === FilterType.CATEGORY ||
			filter?.type === FilterType.NEW_TO_BEACON ||
			filter?.type === FilterType.NEW_TO_MARKET
		) {
			bubbleClickCallback();
			return;
		}
		if (!disabled) {
			if (screenType === ScreenType.TABLET && filter.type !== FilterType.BRAND) {
				handleOpenPanel!();
				dispatch(FilterActions.setCurrentFilterOpenIndex(filter.type!));
			}
			bubbleClickCallback();
		}
	};
	const handleCloseClick = () => {
		if (!disabled) {
			if (bubblesToShow! <= 1) {
				dispatch(FilterActions.clearAllFilters());
				navigate(`/${homePageUrl}`);
			} else {
				dispatch(FilterActions.removeFilter(filter, screenType === ScreenType.MOBILE));
			}
		}
	};
	return (
		<>
			{showBubble && (
				<button
					className={`bubble ${style} ${disabled ? 'disabled' : ''}`}
					id={`bubble${filter.id}`}
				>
					<span data-testid='bubble-item' className='name' onClick={handleBubbleClick}>
						{filter?.name}
					</span>
					<div data-testid='close-bubble' className={'close'} onClick={handleCloseClick}>
						<i className='ri-close-fill icon'></i>
					</div>
				</button>
			)}
		</>
	);
};
